
export const vastBaseStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  backgroundColor: 'transparent',
};
